<template>
  <div class="timestamp">
    <span class="time">{{currentTime}} / {{duration}}</span>
  </div>
</template>

<script>
export default {
  name: 'TimeStamp',
  props: {
    time: {
      type: Number,
      require: true
    },
    videoDuration: {
      type: Number,
      require: true
    }
  },
  computed: {
    currentTime () {
      return this.convertTime(this.time)
    },
    duration () {
      return this.convertTime(this.videoDuration)
    }
  },
  methods: {
    convertTime (time) {
      const minutes = Math.floor(time / 60)
      let seconds = Math.floor(time - minutes * 60)
      seconds = String(seconds).padStart(2, 0)
      return `${minutes}:${seconds}`
    }
  }
}
</script>

<style lang="scss" scoped>
.timestamp {
  color: $color-white;
  @include font('040');

  @include tablet {
    @include font('050');
  }
}
</style>
